var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('MessagePluginLayout', {
    attrs: {
      "message": _vm.props.message,
      "blinkMessageIDList": _vm.props.blinkMessageIDList,
      "showStyle": _vm.pluginMessageType.showStyle,
      "bubbleClassNameList": [_vm.pluginMessageType.pluginType === 'room' ? 'message-bubble-room' : ''],
      "enableFeedback": _vm.props.enableFeedback,
      "enableAINote": _vm.props.enableAINote
    },
    on: {
      "resendMessage": _vm.resendMessage,
      "handleToggleMessageItem": _vm.handleToggleMessageItem,
      "handleH5LongPress": _vm.handleH5LongPress,
      "like": _vm.onLike,
      "dislike": _vm.onDislike
    },
    scopedSlots: _vm._u([{
      key: "messageBubble",
      fn: function () {
        return [_vm.pluginMessageType.pluginType === 'customer' ? _c('MessageCustomerService', {
          attrs: {
            "message": _vm.props.message
          },
          on: {
            "heightChanged": _vm.onHeightChanged,
            "messageSent": _vm.onMessageSent,
            "previewImage": _vm.onPreviewImage
          }
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "messageTip",
      fn: function () {
        return [_c('TimeoutWarning', {
          attrs: {
            "payload": _vm.payload
          }
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }